import { render, staticRenderFns } from "./rechargeTestStatistics.vue?vue&type=template&id=c9ebda40&"
import script from "@/scripts/administrator/rechargeTestStatistics.js?vue&type=script&lang=js&"
export * from "@/scripts/administrator/rechargeTestStatistics.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports